// Bearer (JWT) refresh transport.
//
// The backend refresh is an HttpOnly `refresh_token` cookie + CSRF
// (CustomTokenRefreshSerializer): the call carries no Authorization header,
// instead relying on the cookie (`credentials: "include"`) and echoing the
// `csrftoken` cookie back via `X-CSRFToken`.
//
// This is a ready primitive for the practice-switcher (ENG-1460/T5) — it is NOT
// wired to any expiry/refresh loop here because no Bearer session exists yet.
// Live cross-host cookie domain/path verification is deferred until backend T3
// lands. `baseUrl` is passed in (rather than read from `import.meta.env`) so
// this module stays unit-testable under ts-jest.
import { getCsrfToken } from "utils/auth-header.util";

// Endpoint assumed from the SimpleJWT convention; confirm against backend T3.
const REFRESH_PATH = "/auth/jwt/refresh/";

export type RefreshResult = {
  access: string;
} | null;

export const refreshBearerToken = async (
  baseUrl: string
): Promise<RefreshResult> => {
  try {
    const response = await fetch(`${baseUrl}${REFRESH_PATH}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCsrfToken()
      }
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.access ? { access: data.access } : null;
  } catch {
    return null;
  }
};
